'use strict';

angular
    .module('App.v1.Directives')
    .directive('nanpPhoneNumber', ['App.v1.Services.PhoneNumberValidation', function(phoneValidationService) {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModelCtrl) {
                
                // Initialize errorMessages collection if it doesn't exist
                if (!ngModelCtrl.errorMessages) {
                    ngModelCtrl.errorMessages = {};
                }
                
                // Add validator to the ngModel controller
                ngModelCtrl.$validators.nanpPhoneNumber = function(modelValue, viewValue) {
                    // Use the shared validation service
                    var result = phoneValidationService.validateNanp(viewValue);

                    // Add or remove error message from collection
                    if (!result.isValid) {
                        ngModelCtrl.errorMessages.nanpPhoneNumber = result.errorMessage;
                    } else {
                        delete ngModelCtrl.errorMessages.nanpPhoneNumber;
                    }
                    
                    return result.isValid;
                };
            }
        };
    }]);
